export const REQUESTS = `
  query requests(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: RequestOrderInput
    $filter: FilterRequestInput
    $searchText: String
  ) {
    requests(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Request {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
          company {
            id
            name
            cuit
            employees
            income
            income_company_incomeToincome {
              id
              name
            }
            company_industry {
              id
              name
            }
          }
          contact_contact_status {
            id
            contact_type
            end_date
            status {
              id
              name
              hex_color
            }
          }
          member {
            id
            start_date
            license_count_last_12_months
            group_member {
              id
              group_id
              group {
                id
                name
              }
            }
          }
        }
        request_reason_id
        request_reason {
          id
          name
          translation_key
          manual
          contact_type
          parameters
        }
        status_id
        request_status {
          id
          name
          translation_key
          hex_color
        }
        description
        data
        decision_message
        decision_date
        decision_user_id
        continue_as_member
        group_change
        contact_member_retention
        new_group_id
        send_leave_poll
        created_by
        created_by_user {
          id
          email
          contact {
            id
            firstname
            lastname
          }
        }
        its
        uts
        pdf
        administration_preprocessed
        group_movement {
          id
          group_id
          its
          group {
            id
            name
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REQUEST_COUNT = `
  query requestCount(
    $tenant_id: Int!
    $filter: FilterRequestInput
    $searchText: String
  ) {
    requestCount(
      tenant_id: $tenant_id
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REQUEST = `
  query request(
    $id: Float!
    $tenant_id: Int!
  ) {
    request(
      id: $id
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          company {
            id
            name
            cuit
          }
          contact_contact_status {
            id
            contact_type
            end_date
            status {
              id
              name
              hex_color
            }
          }
          member {
            id
            start_date
            license_count_last_12_months
            group_member {
              id
              group_id
              group {
                id
                name
              }
            }
          }
        }
        request_reason_id
        request_reason {
          id
          name
          translation_key
          manual
          contact_type
          parameters
        }
        status_id
        request_status {
          id
          name
          translation_key
          hex_color
        }
        description
        data
        decision_message
        decision_date
        decision_user_id
        continue_as_member
        group_change
        contact_member_retention
        new_group_id
        send_leave_poll
        created_by
        created_by_user {
          id
          email
          contact {
            id
            firstname
            lastname
          }
        }
        its
        uts
        pdf
        administration_preprocessed
        group_movement {
          id
          group_id
          its
          group {
            id
            name
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;


export const GET_REQUEST_PDF_URL = `
  query getRequestPdfUrl($id: Int!, $tenant_id: Int!) {
    getRequestPdfUrl(id: $id, tenant_id: $tenant_id) {
      url
    }
  }
`;

